import React from 'react'

export default function Footer() {
  return <div className='px-[5vw] pb-10 md:-mt-[5vw] mt-5 relative z-50'>
    <div className='grid md:grid-cols-12 grid-cols-1 gap-5'>
      <div className='md:col-span-4 col-span-full'>
        <img src="/images/logo.png" alt="" className='-ml-2 animate__fadeInUp animate__animated wow' />
        <p className='md:block hidden animate__fadeInUp animate__animated wow'>Copyright © 2024 CHINU AI. All Rights Reserved</p>
      </div>
      <div className='md:col-span-4 col-span-full md:pl-10'>
        <h2 className='text-xl text-[#FFFD0F] font-semibold mb-5'>MENU ITEMS</h2>
        <div className='flex items-center gap-10'>
          <div className='flex flex-col gap-2 text-gray-400'>
            <a href="" className='md:text-lg text-sm animate__fadeInUp animate__animated wow'>Key Selling Points</a>
            <a href="" className='md:text-lg text-sm animate__fadeInUp animate__animated wow animate__delay-1s'>Core Features</a>
            <a href="" className='md:text-lg text-sm animate__fadeInUp animate__animated wow animate__delay-2s'>About Chinu Inu</a>
          </div>
          <div className='flex flex-col gap-2 text-gray-400'>
            <a href="" className='md:text-lg text-sm animate__fadeInUp animate__animated wow'>Why Choose Chinu Inu?</a>
            <a href="" className='md:text-lg text-sm animate__fadeInUp animate__animated wow animate__delay-1s'>How it works</a>
            <a href="" className='md:text-lg text-sm animate__fadeInUp animate__animated wow animate__delay-2s'>Join Us</a>
          </div>
        </div>
      </div>
      <div className='md:col-span-2 col-span-full'>
        <h2 className='text-xl text-[#FFFD0F] font-semibold mb-5 uppercase'>socials</h2>
        <div className='flex items-center gap-4'>
          <a href="" className='block'>
            <img src="/images/t.png" alt="" className='md:w-[5vw] w-[12vw] animate__fadeInUp animate__animated wow' />
          </a>
          <a href="" className='block'>
            <img src="/images/x.png" alt="" className='md:w-[5vw] w-[12vw] animate__fadeInUp animate__animated wow animate__delay-1s' />
          </a>
          <a href="" className='md:hidden block'>
            <img src="/images/telegram.png" alt="" className='md:w-[17vw] w-[37vw] animate__fadeInUp animate__animated wow animate__delay-2s' />
          </a>
        </div>
      </div>
      <div className='md:col-span-2 col-span-full flex md:items-end items-center justify-center md:justify-end'>
        <a href="" className='md:block hidden'>
          <img src="/images/telegram.png" alt="" className='w-[17vw]' />
        </a>
        <p className='md:hidden block !text-[12px]'>Copyright © 2024 CHINU AI. All Rights Reserved</p>
      </div>
    </div>

  </div>
}
